import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { RapportState } from './state';
import { RAPPORT } from '@/modules/Rapport/store/mutation-types';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import ErrorManager from '@/common/utils/ErrorManager';
import { RapportActions, RapportActionTypes } from '@/modules/Rapport/store/action-types';
import RapportService, { FilterRapport, RapportToDownload } from '@/modules/Rapport/services/RapportService';

export const actions: ActionTree<RapportState, RootState> = {
    async [RapportActions.GET_RAPPORT]({commit}: RapportActionTypes, payload: FilterRapport){
        commit(RAPPORT.SET_ERROR, undefined);
        commit(RAPPORT.SET_IS_LOADING, true);
        commit(RAPPORT.SET_PAGE, payload.page);
        try {
            const response = await RapportService.getRapports(payload);
            if (response.status === 200 && response.data !== undefined) {
                if(payload.isForModal) {
                    commit(RAPPORT.SET_NB_RAPPORT, response.headers.count);
                }
                if (payload.page === 0) {
                    commit(RAPPORT.SET_ITEMS, response.data);
                    commit(RAPPORT.SET_SCROLL, 0);
                    commit(RAPPORT.SET_NB_OF_PAGES, response.headers.pages);
                    commit(RAPPORT.SET_COUNT, response.headers.count);
                } else {
                    commit(RAPPORT.ADD_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(RAPPORT.SET_IS_LOADING, false);

        } catch (error) {
            commit(RAPPORT.SET_IS_LOADING, false);
            commit(RAPPORT.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [RapportActions.GET_RAPPORT_PDF]({commit}: RapportActionTypes, payload: RapportToDownload){
        commit(RAPPORT.SET_ERROR, undefined);
        commit(RAPPORT.SET_ZIP_IS_LOADING, true);
        try {
            const response = await RapportService.getRapportPDF(payload);
            if (response.status === 200 && response.data !== undefined) {
                let blob;
                if(payload.interventionIds?.length === 1) {
                    blob =  new Blob([response.data], { type: 'application/pdf' });
                } else {
                    blob =  new Blob([response.data], { type: 'application/zip' });
                }
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.target = 'blank';
                if(payload.interventionIds?.length === 1) {
                    link.download =  "Rapport d'intervention " + payload.interventionIds[0];
                } else {
                    link.download = payload.nomZip === undefined ? "Rapports d'intervention" : payload.nomZip;
                }
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(RAPPORT.SET_ZIP_IS_LOADING, false);
        } catch (error) {
            commit(RAPPORT.SET_ERROR, error);
            commit(RAPPORT.SET_ZIP_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [RapportActions.GET_ALL_RAPPORT_PDF]({commit}: RapportActionTypes, payload: FilterRapport){
        commit(RAPPORT.SET_ERROR, undefined);
        commit(RAPPORT.SET_ZIP_IS_LOADING, true);
        try {
            const response = await RapportService.getAllRapportPDF(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob =  new Blob([response.data], { type: 'application/zip' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.target = 'blank';
                link.download = payload.nomZip === undefined ? "Rapports d'intervention" : payload.nomZip;
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(RAPPORT.SET_ZIP_IS_LOADING, false);
        } catch (error) {
            commit(RAPPORT.SET_ERROR, error);
            commit(RAPPORT.SET_ZIP_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
